module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_35.ead84650.mp3";